<template>
	<div>
		<table-header
			:label="label"
			:count="totalItems"
			:page-size="pageSize"
			:current-page="currentPage"
			:pages="pages"
			:page-sizes="pageOptions"
			@update:page-size="$emit('update:pageSize', $event)"
			@page-change="$emit('page-change', $event)"
		>
			<template #toggle>
				<view-toggle
					v-if="hasMultipleViews"
					:view-mode="viewMode"
					class="hidden sm:block"
					@toggle="$emit('update:viewMode', $event)"
				/>
			</template>
		</table-header>

		<div v-if="effectiveViewMode === 'table' && !loading" class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<div v-if="totalItems > 0" class="listHeader hidden sm:block">
					<div class="row">
						<template v-for="column in allowedColumns" :key="column.key">
							<div
								:class="[
									column.class || 'col-xs-12 col-sm-4 col-md-3 col-lg-3',
									{ cursorPointer: column.sortable }
								]"
								@click="handleSort(column)"
							>
								<p class="truncate">
									{{ column.label }}
									<span
										v-if="column.sortable"
										:class="{
											'fa-light fa-chevron-down': sortColumn === column.key && reverse,
											'fa-light fa-chevron-up': sortColumn === column.key && !reverse
										}"
									></span>
								</p>
							</div>
						</template>
					</div>
				</div>

				<slot name="table-view"></slot>
			</div>
		</div>

		<div v-else-if="hasCardView && !loading" class="px-0 pt-2">
			<div v-if="totalItems === 0" class="flex h-[200px] w-full items-center justify-center">
				<p class="text-gray-500">No {{ label.toLowerCase() }} found</p>
			</div>
			<div
				v-else-if="!customCard"
				class="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
			>
				<slot name="card-view"></slot>
			</div>
			<div v-else class="w-full">
				<slot name="card-view"></slot>
			</div>
		</div>

		<loading-spinner v-if="loading" />

		<table-header
			v-if="!loading && pages.length > 1"
			:label="label"
			:count="totalItems"
			bottom
			:page-size="pageSize"
			:current-page="currentPage"
			:pages="pages"
			:page-sizes="pageOptions"
			@update:page-size="$emit('update:pageSize', $event)"
			@page-change="$emit('page-change', $event)"
		/>
	</div>
</template>

<script>
export default {
	inject: ['tenants', 'userRoles'],
	props: {
		viewMode: {
			type: String,
			default: 'table',
			validator: (value) => ['table', 'card'].includes(value)
		},
		columns: {
			type: Array,
			required: true
		},
		sortColumn: String,
		reverse: Boolean,
		loading: Boolean,
		label: String,
		permission: String,
		customCard: Boolean,
		totalItems: Number,
		pageSize: Number,
		currentPage: Number,
		pages: Array,
		pageOptions: {
			type: Array,
			default: () => [25, 50, 100]
		}
	},
	emits: ['sort', 'update:pageSize', 'page-change', 'update:viewMode'],
	data() {
		return {
			windowWidth: window.innerWidth
		}
	},
	computed: {
		hasCardView() {
			return !!this.$slots['card-view']
		},
		hasTableView() {
			return !!this.$slots['table-view']
		},
		hasMultipleViews() {
			return this.hasCardView && this.hasTableView
		},
		isMobile() {
			return this.windowWidth < 640
		},
		effectiveViewMode() {
			return this.isMobile && this.hasCardView ? 'card' : this.viewMode
		},
		allowedColumns() {
			return this.columns.filter((column) => {
				if (column.key === 'tenant') {
					return this.tenants?.length > 1 || this.$global.hasUserRole(this.userRoles, 'reseller')
				}
				return !column.permission || this.$global.hasUserRole(this.permission, column.permission)
			})
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		handleSort(column) {
			if (column.sortable) {
				const newReverse = this.sortColumn === column.key ? !this.reverse : false
				this.$emit('sort', column.key, newReverse)
			}
		},
		handleResize() {
			this.windowWidth = window.innerWidth
		}
	}
}
</script>
